export class GzzBankAccount {

  OwnerName: string;
  OwnerID: string;
  BankNumber: number;
  BranchNumber: number;
  AccountNumber: string;

  constructor(data: GzzBankAccount) {

    Object.assign(this, data);

    if (data) {

      if (data['Bank']) {
        this.BankNumber = data['Bank']['Bank_Code'];
      }

      if (data['Branch']) {
        this.BranchNumber = data['Branch']['Branch_Code'];
      }
    }

    delete this['Bank'];
    delete this['Branch'];
  }
}



// WEBPACK FOOTER //
// E:/Develop/MOH.Gazezet/Dev/MOH.Gazzezet/MOH.Gazzezet/src/app/models/general/GzzBankAccount.ts